import { useCallback, useState } from "react";
import ItemContainer from "../ItemContainer.tsx";
import type { ShowFieldOptionsSettings } from "../Types.ts";
import ConditionItem from "./ConditionItem.tsx";
import { formatCaption } from "./conditionsHelper.tsx";

import type { ConditionField } from "../../../../../../../../api/types/svTypes.ts";

export const ConditionItemContainer = (props: {
  field: ConditionField;
  canBeRemoved: boolean;
  readonly?: boolean;
  disableEqualitySelection?: boolean;
  onRemoveItem?: (item: ConditionField) => void;
  showOptions: (settings: ShowFieldOptionsSettings<ConditionField>) => void;
}) => {
  const { field, canBeRemoved, readonly, onRemoveItem, showOptions, disableEqualitySelection } = props;

  const [containerElementRef, setContainerElementRef] = useState<HTMLElement | null>(null);

  const getCaption = useCallback(() => {
    return formatCaption(field, undefined, disableEqualitySelection);
  }, [field, disableEqualitySelection]);

  const onShowOptions = useCallback(
    (settings: ShowFieldOptionsSettings<ConditionField>) => {
      if (!showOptions) return;
      const ref = settings.showOnlySelected ? containerElementRef : settings.ref;
      if (!ref) return;

      showOptions({ field, ref, showOnlySelected: settings.showOnlySelected });
    },
    [containerElementRef, field, showOptions]
  );

  return (
    <ItemContainer setRef={setContainerElementRef}>
      <ConditionItem
        field={field}
        canBeRemoved={canBeRemoved}
        readonly={readonly ?? false}
        onShowOptions={onShowOptions}
        onRemoveItem={onRemoveItem}
        formatCaption={getCaption}
        onSetAutoShowItemOptionsId={undefined}
      />
    </ItemContainer>
  );
};

export default ConditionItemContainer;
